export default class Nav {
    static instance = null;

    constructor(el) {
        this.$el = $(el)
        this.menuItem = this.$el.find('[data-element="nav:menu-item"]')
        this.init()
        this.$el[0].controller = this
        Nav.instance = this;
    }
    init() {
        this.menuItem.on('click', (e) => {
            $('.nav__submenu').removeClass('active')
            $('.nav__item').removeClass('active')
            e.stopPropagation()
            $(e.currentTarget).addClass('active')
        })
        $('body').on('click', (e) => {
            this.menuItem.removeClass('active')
        })
    }
}
